<template>
  <div v-if="show" class="pa-2">
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="checkForm">
      <v-row dense>
        <!-- Nombre del Mercado -->
        <v-col cols="12" class="pb-0">
          <v-text-field
            v-model.trim="nm"
            :rules="rules.nombre"
            label="Nombre del Mercado de Reserva"
            placeholder="Ej. Directo, OTA, Mayorista, Agencia"
            outlined
            dense
            required
            autofocus
          ></v-text-field>
        </v-col>

        <!-- Estatus Activo -->
        <v-col cols="12" class="pb-0">
          <v-switch
            v-model="activo"
            :label="activo ? 'Mercado Activo' : 'Mercado Inactivo'"
            color="success"
            dense
            inset
          ></v-switch>
        </v-col>

        <!-- Botones de Acción -->
        <v-col cols="12" class="text-right pt-4">
          <v-btn color="red" dark class="mr-2" @click="$emit('toggle', false)">
            Cancelar
          </v-btn>
          <v-btn color="green" dark type="submit">
            Guardar
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
export default {
  name: "MercadosForm",
  props: {
    edit: {
      type: Boolean,
      default: false,
    },
    dataEdit: {
      type: Object,
      default: () => ({}),
    },
    show: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      valid: true,
      id: "",
      nm: "",
      activo: true,

      rules: {
        nombre: [
          (v) => !!v || "El nombre del mercado es obligatorio",
          (v) => (v && v.trim().length >= 2) || "Debe tener al menos 2 caracteres",
        ],
      },
    };
  },
  methods: {
    create() {
      const payload = {
        id: this.id || "",
        nm: this.nm,
        nombre: this.nm,
        activo: this.activo,
      };

      this.$alert.alertConfirm({
        action: "crear",
        obj: "Mercado de reserva",
        route: "RVA-MercadosReserva-createMercadoReserva",
        data: payload,
        onSuccess: () => {
          this.$pgsHelper.writeLog({
            Evento: "CREATE_MERCADO_RESERVA",
            Mensaje: `Creacion de mercado de reserva ${this.nm}`,
            reference: {
              id: this.id || "N/A",
              tp: "MERCADO_RESERVA",
              al: "Mercado de reserva",
            },
            data: payload,
          });
          this.$emit("reload");
          this.$emit("toggle", false);
        },
      });
    },
    editMercado() {
      const payload = {
        id: this.id,
        nm: this.nm,
        nombre: this.nm,
        activo: this.activo,
      };

      this.$alert.alertConfirm({
        action: "editar",
        obj: "Mercado de reserva",
        route: "RVA-MercadosReserva-updateMercadoReserva",
        data: payload,
        onSuccess: () => {
          this.$pgsHelper.writeLog({
            Evento: "UPDATE_MERCADO_RESERVA",
            Mensaje: `Edicion de mercado de reserva ${this.nm}`,
            reference: {
              id: this.id,
              tp: "MERCADO_RESERVA",
              al: "Mercado de reserva",
            },
            data: payload,
          });
          this.$emit("reload");
          this.$emit("toggle", false);
        },
      });
    },
    resetForm() {
      this.id = "";
      this.nm = "";
      this.activo = true;
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    checkForm() {
      if (this.$refs.form && this.$refs.form.validate()) {
        if (this.edit) {
          this.editMercado();
        } else {
          this.create();
        }
      }
    },
    populateFromData(data) {
      if (this.edit && data && Object.keys(data).length > 0) {
        this.id = data.id || "";
        this.nm = data.nm || data.nombre || data.Nombre || "";
        this.activo =
          data.activo !== undefined
            ? data.activo
            : data.Activo !== undefined
            ? data.Activo
            : true;
      } else if (!this.edit) {
        this.id = "";
        this.nm = "";
        this.activo = true;
      }
    },
  },
  watch: {
    dataEdit: {
      immediate: true,
      handler(newVal) {
        this.populateFromData(newVal);
      },
    },
  },
  mounted() {
    this.populateFromData(this.dataEdit);
  },
};
</script>

<style scoped>
</style>
